import { SharedModule } from 'src/app/shared/shared.module'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import * as fromGate from './gate.reducer'
import { GateEffects } from './gate.effects'
import { GateSerializer } from './gate.serializer'
import { GateService } from './gate.service'

@NgModule({
  imports: [
    SharedModule,
    StoreModule.forFeature(fromGate.FEATURE_NAME, fromGate.gateReducer),
    EffectsModule.forFeature([GateEffects])
  ],
  declarations: [],
  exports: [],
  providers: [
    GateService,
    {
      provide: GateSerializer,
      useClass: GateSerializer
    }
  ]
})
export class GateModule {}
